import { Location } from 'interfaces';

export const locationsList: Location[] = [new Location()];
